import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '../../../shared/components/buttons/button/button.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lead-travellers-modal',
  standalone: true,
  imports: [ButtonComponent, CommonModule],
  templateUrl: './travellers-modal.component.html',
  styleUrls: ['./travellers-modal.component.scss'],
})
export class TravelersModalComponent {
  @Input() isTravellerApplyEnabled: boolean = false;
  @Input() adultsCount = 0;
  @Input() infantsCount = 0;
  @Input() childrenCount = 0;

  @Output() applyTravellers = new EventEmitter<any>();

  increaseAdults() {
    this.adultsCount++;
    this.isTravellerApplyEnabled = true;
  }

  decreaseAdults() {
    if (this.adultsCount > 0) {
      this.adultsCount--;
    }

    if (this.adultsCount == 0) {
      this.isTravellerApplyEnabled = false;
    }
  }

  increaseChildren() {
    this.childrenCount++;
  }

  decreaseChildren() {
    if (this.childrenCount > 0) {
      this.childrenCount--;
    }
  }

  increaseInfants() {
    this.infantsCount++;
  }

  decreaseInfants() {
    if (this.infantsCount > 0) {
      this.infantsCount--;
    }
  }

  applyTravellerChanges() {
    this.applyTravellers.emit({
      adultsCount: this.adultsCount,
      childrenCount: this.childrenCount,
      infantsCount: this.infantsCount,
    });
  }
}
